L.Control.ShareControl = L.Control.extend({

    initialize: function (options) {
        L.Util.setOptions(this, options);
    },

    _hasRoute: function() {
        return control._selectedRoute && control._selectedRoute.geometry;
    },

    _exportGpx: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

	window.location.href = control.getRouter().buildRouteUrl(control.getWaypoints(), control.getPlan().options, control._selectedRoute, true) + "&output=gpx";
    },

    _exportKml: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

        window.location.href = control.getRouter().buildRouteUrl(control.getWaypoints(), control.getPlan().options, control._selectedRoute, true) + "&output=kml";
    },

    show: function() {

        var container = L.DomUtil.get('share-container');

        this._showSavedRoutes();

        /* Export GPX & KML */
        var exportContainer = L.DomUtil.create('div', 'gpx-container', container);
        var exportParagraph = L.DomUtil.create('p', '', exportContainer);
        exportParagraph.innerHTML = L.localisation.get('share.exportMessage');
        var exportGpxButton = L.DomUtil.create('a', 'btn btn-small btn-gpx', exportContainer);
        exportGpxButton.innerHTML = L.localisation.get('share.exportGpx');
        L.DomEvent.on(exportGpxButton, 'click', this._exportGpx, this);
        var exportKmlButton = L.DomUtil.create('a', 'btn btn-small btn-kml', exportContainer);
        exportKmlButton.innerHTML = L.localisation.get('share.exportKml');
        L.DomEvent.on(exportKmlButton, 'click', this._exportKml, this);

        /* Link sharing */
        var linkContainer = L.DomUtil.create('div', 'shorten-container', container);
        var linkParagraph = L.DomUtil.create('p', '', linkContainer);
        linkParagraph.innerHTML = L.localisation.get('share.shareableLinkMessage');
        this.linkInput = L.DomUtil.create('input', 'shorten-input', linkContainer);
        this.linkInput.value = '';
        this.linkInput.disabled = true;
        var linkButton = L.DomUtil.create('a', 'btn btn-small btn-block', linkContainer);
        linkButton.innerHTML = L.localisation.get('share.shareableLink');
        L.DomEvent.on(linkButton, 'click', this._shortenUrl, this);
        
        return this;
    },

    _showSavedRoutes: function() {

        var container = L.DomUtil.get('share-container');

        // Logged-in state
        var savedRoutesContainer = L.DomUtil.get('favs-logged-in-container');
        var savedRoutesIntro = L.DomUtil.create('div', 'saved-routes-intro', savedRoutesContainer);
        var savedRoutesTitle = L.DomUtil.create('span', '', savedRoutesIntro);
        savedRoutesTitle.innerHTML = L.localisation.get('share.yourSavedRoutes');
        var jsSignOutButton = L.DomUtil.create('a', 'saved-routes-signout', savedRoutesIntro);
        jsSignOutButton.setAttribute('href','javascript:void(0)');
        jsSignOutButton.innerHTML = L.localisation.get('share.logout');
        this._jsSignOutButton = jsSignOutButton;
        L.DomEvent.on(jsSignOutButton, 'click', this._signOut, this);

        // Google auth
        var loginContainer = L.DomUtil.get('favs-login-container');
        loginContainer.setAttribute('style','display:block');
        var loginIntro = L.DomUtil.create('p', 'login-intro', loginContainer);
        loginIntro.innerHTML = L.localisation.get('share.loginMessage');
        var jsSignInButton = L.DomUtil.create('a', '', loginContainer);
        jsSignInButton.setAttribute('style','cursor:pointer');
        jsSignInButton.innerHTML = '<img src="/static/google-btn.png" style="margin:0 12px 3px 0" />';
        this._jsSignInButton = jsSignInButton;

        // Apple auth (not shown on Android devices)
        if (!L.Browser.android && typeof AppleID !== 'undefined') {

             var appleSignInButton = L.DomUtil.create('a', '', loginContainer);
             appleSignInButton.setAttribute('style','cursor:pointer');
             appleSignInButton.innerHTML = '<img src="/static/apple-btn.png" style="margin: 3px 0" />';
             this._appleSignInButton = appleSignInButton;
             L.DomEvent.on(appleSignInButton, 'click', function() {
                 this._runAuth('apple', 'sign-in', function() { return AppleID.auth.signIn(); });
             }, this);

             this._runAuth('apple', 'initialize', function() {
                 return AppleID.auth.init({
                     clientId : 'com.trailrouter.apple',
                     scope : 'email',
                     redirectURI : 'https://'+window.location.hostname+'/redirect',
                     state : '345jb34k5lyu345bbgdfg',
                     usePopup : true
                 });
             });
            L.DomEvent.on(document, 'AppleIDSignInOnSuccess', function(data) {
                 this.signInCallback(data.detail.authorization.code, "apple");
            }, this);
            document.addEventListener('AppleIDSignInOnFailure', L.bind(function(event) {
                 this._authFailure('apple', 'sign-in', event.detail);
            }, this));
        }

        this._initializeGoogleAuth();
        this._renderLoginFallback();

        // Show route list
        this._routeTable = L.DomUtil.create('table','saved-routes',savedRoutesContainer);
        // Save button
        var saveRouteButton = L.DomUtil.create('a', 'btn btn-small btn-block', savedRoutesContainer);
        saveRouteButton.innerHTML = L.localisation.get('share.saveCurrentRoute');
        saveRouteButton.style.margin = '10px 0 0 0';
        L.DomEvent.on(saveRouteButton, 'click', this._saveRoute, this);

        // Set token if already logged in
        var token;
        try { token = localStorage.getItem('accessToken'); } catch (error) {}
        if (token != null) {
           this._accessToken = token;
           this._signInComplete();
        }
    },

    _initializeGoogleAuth: function() {
        // Provider initialization is independent of an existing Trail Router session.
        this._googleAuthReady = false;
        L.DomEvent.on(this._jsSignInButton, 'click', function() {
            if (this._webLoginBlocked()) return;
            if (!this._googleAuthReady) {
                this._authFailure('google', 'sign-in', new Error('Google sign-in is unavailable'));
                return;
            }
            // Own the handler so a later fallback can prevent the SDK opening a popup.
            this._runAuth('google', 'sign-in', L.bind(function() { return this._auth2.signIn(); }, this),
                L.bind(function(googleUser) {
                    this.signInCallback(googleUser.getAuthResponse().id_token, 'google');
                }, this));
        }, this);
        var failed = L.bind(function(error) {
            this._googleAuthReady = false;
            this._authFailure('google', 'initialize', error);
        }, this);
        try {
            if (typeof gapi === 'undefined' || this._webLoginBlocked()) return;
            gapi.load('auth2', L.bind(function() {
                if (this._webLoginBlocked()) return;
                try {
                    var auth2 = this._auth2 = gapi.auth2.init({
                        client_id: '160848283571-q23k0se0hsbi4ijrib87qbrd953k877a.apps.googleusercontent.com',
                        cookiepolicy: 'single_host_origin'
                    });
                    auth2.then(L.bind(function() {
                        if (!this._webLoginBlocked()) this._googleAuthReady = true;
                    }, this), failed);
                } catch (error) { failed(error); }
            }, this));
        } catch (error) { failed(error); }
    },

    _runAuth: function(provider, operation, run, success) {
        if (operation !== 'sign-out' && this._webLoginBlocked()) return;
        this._lastAuthFailure = null;
        if (window.TrailRouterDiagnostics) TrailRouterDiagnostics.breadcrumb('auth.' + operation, { provider: provider });
        var failure = L.bind(function(error) { this._authFailure(provider, operation, error); }, this);
        try {
            var result = run();
            if (result && typeof result.then === 'function') {
                result.then(L.bind(function(value) {
                    if (operation !== 'sign-out' && this._webLoginBlocked()) return;
                    try { if (success) success(value); } catch (error) { failure(error); }
                }, this), failure);
            }
        } catch (error) { failure(error); }
    },

    _webLoginBlocked: function() {
        return !!this._loginRequiresBrowser;
    },

    _isEmbeddedBrowser: function() {
        var ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
        // These are hints only; never disable login without an actual provider failure.
        // Mac-style WebViews can be labelled Apple Mail by UA parsers, even in other apps.
        return /;\s*wv\)|\bFBAN\/|\bFBAV\/|Instagram|\bLine\//i.test(ua) ||
            (/AppleWebKit/i.test(ua) && /iPhone|iPad|iPod|Macintosh/i.test(ua) &&
                !/Safari\/|Chrome\/|Chromium\/|Firefox\/|Edg\/|OPR\/|CriOS\/|FxiOS\/|EdgiOS\/|OPiOS\//i.test(ua));
    },

    _classifyAuthFailure: function(provider, operation, error) {
        var code = typeof error === 'string' ? error : error && (error.error || error.code);
        var allowed = ['user_cancelled_authorize', 'popup_closed_by_user', 'access_denied',
            'user_trigger_new_signin_flow', 'idpiframe_initialization_failed', 'popup_blocked_by_browser',
            'disallowed_useragent', 'unsupported_browser', 'browser_not_supported', 'immediate_failed'];
        code = allowed.indexOf(code) === -1 ? 'unknown' : code;
        var cancelled = ['user_cancelled_authorize', 'popup_closed_by_user', 'access_denied',
            'user_trigger_new_signin_flow'].indexOf(code) !== -1;
        var embedded = this._isEmbeddedBrowser();
        var webLogin = (provider === 'google' || provider === 'apple') &&
            (operation === 'initialize' || operation === 'sign-in');
        var disallowed = provider === 'google' && code === 'disallowed_useragent';
        var unsupported = disallowed || code === 'unsupported_browser' || code === 'browser_not_supported';
        return {
            code: code,
            cancelled: cancelled,
            embeddedBrowser: embedded,
            fallback: webLogin && !cancelled && (unsupported || code === 'popup_blocked_by_browser' ||
                (provider === 'google' && operation === 'initialize' && embedded)),
            // A generic iframe failure or blocked popup does not prove an embedded-browser restriction.
            expected: webLogin && (disallowed || (embedded && unsupported))
        };
    },

    _renderLoginFallback: function() {
        var blocked = this._webLoginBlocked();
        if (this._jsSignInButton) this._jsSignInButton.style.display = blocked ? 'none' : '';
        if (this._appleSignInButton) this._appleSignInButton.style.display = blocked ? 'none' : '';
        if (!this._loginFallback && blocked) {
            var container = this._loginFallback = L.DomUtil.create('div', 'login-browser-fallback', L.DomUtil.get('favs-login-container'));
            var message = L.DomUtil.create('p', '', container);
            message.textContent = L.localisation.get('share.loginRequiresBrowser');
            this._copyLoginLinkButton = L.DomUtil.create('button', 'btn btn-small', container);
            this._copyLoginLinkButton.type = 'button';
            this._copyLoginLinkButton.textContent = L.localisation.get('share.copyLink');
            L.DomEvent.on(this._copyLoginLinkButton, 'click', this._copyLoginLink, this);
            this._loginCopyStatus = L.DomUtil.create('p', 'login-copy-status', container);
            this._loginCopyStatus.setAttribute('role', 'status');
            this._loginCopyStatus.setAttribute('aria-live', 'polite');
            this._loginCopyUrl = L.DomUtil.create('input', 'login-copy-url', container);
            this._loginCopyUrl.type = 'text';
            this._loginCopyUrl.readOnly = true;
            this._loginCopyUrl.setAttribute('aria-label', L.localisation.get('share.manualCopyLink'));
            this._loginCopyUrl.style.display = 'none';
        }
        if (this._loginFallback) this._loginFallback.style.display = blocked ? 'block' : 'none';
    },

    _copyLoginLink: function() {
        var url = window.location.href;
        var request = this._loginCopyRequest = (this._loginCopyRequest || 0) + 1;
        this._loginCopyStatus.textContent = '';
        this._loginCopyUrl.style.display = 'none';
        var complete = L.bind(function(copied) {
            if (request !== this._loginCopyRequest) return;
            this._loginCopyStatus.textContent = L.localisation.get(copied ? 'share.linkCopied' : 'share.manualCopyLink');
            if (!copied) {
                this._loginCopyUrl.value = url;
                this._loginCopyUrl.style.display = 'block';
                this._loginCopyUrl.focus();
                this._loginCopyUrl.select();
            }
        }, this);
        try {
            if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(function() { complete(true); }, function() { complete(false); });
            } else complete(false);
        } catch (error) { complete(false); }
    },

    _authFailure: function(provider, operation, error) {
        var failure = this._classifyAuthFailure(provider, operation, error);
        if (failure.cancelled) return;
        if (failure.fallback) {
            this._loginRequiresBrowser = true;
            this._googleAuthReady = false;
            this._renderLoginFallback();
        }
        var key = provider + ':' + operation + ':' + failure.code;
        if (this._lastAuthFailure && this._lastAuthFailure.key === key && Date.now() - this._lastAuthFailure.time < 1000) return;
        this._lastAuthFailure = { key: key, time: Date.now() };
        if (window.TrailRouterDiagnostics && !failure.expected) {
            // Do not attach the provider response: it may contain credentials.
            TrailRouterDiagnostics.report(new Error('Authentication ' + operation + ' failed'),
                { provider: provider, operation: operation, providerCode: failure.code,
                    embeddedBrowser: failure.embeddedBrowser, loginFallbackActivated: !!this._webLoginBlocked() });
        }
        // No sign-in was attempted. Keep routing and restored sessions usable.
        if (operation === 'initialize' || failure.fallback) return;
        var message = L.DomUtil.get('routing-error');
        message.textContent = operation === 'sign-out' ? 'Unable to sign out. Please try again.' : 'Unable to sign in. Please try again.';
        message.style.visibility = 'visible';
    },

    _signOut: function() {
        // The local session must end even if a provider is unavailable or rejects sign-out.
        this.signOutCallback();
        if (this._auth2 && typeof this._auth2.signOut === 'function') {
            this._runAuth('google', 'sign-out', L.bind(function() { return this._auth2.signOut(); }, this));
        }
    },

    _safeRouteUrl: function(value) {
        if (typeof value !== 'string' || !value.trim()) return null;
        try {
            var url = new URL(value, window.location.href);
            if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
        } catch (error) {}
        return null;
    },

    _refreshSavedRouteList: function() {

        this._restCall('GET', '/ors/savedroutes', null, L.bind(function(resp) {
            this._savedRoutes = JSON.parse(resp);
            this._displaySavedRouteList();
        },this));
    },

    _displaySavedRouteList: function() {
        var tr, td, a;

        while (this._routeTable.firstChild) {
           this._routeTable.removeChild(this._routeTable.firstChild);
        }

        // Handle no saved routes
        if (!this._savedRoutes || this._savedRoutes.length == 0) {
           tr = L.DomUtil.create('tr', '', this._routeTable);
           td = L.DomUtil.create('td', '', tr);
           td.innerHTML = L.localisation.get('share.noSavedRoutes');
        }

        // Create table of saved routes
        for (var i = 0; i < (this._savedRoutes || []).length; i++) {
           tr = L.DomUtil.create('tr', '', this._routeTable);
           tr.setAttribute('data-route-id', this._savedRoutes[i].id);

           // route name and link
           td = L.DomUtil.create('td', 'c1', tr);
           a = L.DomUtil.create('a','',td);
           a.textContent = this._savedRoutes[i].name;
           var routeUrl = this._safeRouteUrl(this._savedRoutes[i].url);
           if (routeUrl) a.href = routeUrl;
           L.DomEvent.addListener(a, 'mousedown', L.DomEvent.preventDefault);

           // rename link
           td = L.DomUtil.create('td', 'c2', tr);
           a = L.DomUtil.create('a','',td);
           a.setAttribute('data-route-id', this._savedRoutes[i].id);
           a.setAttribute('style','cursor:pointer');
           a.innerHTML = '<i class="fa fa-pencil-square-o"></i>';
           L.DomEvent.addListener(a, 'click', L.bind(this._renameRoute,this));

           // delete link
           td = L.DomUtil.create('td', 'c3', tr);
           a = L.DomUtil.create('a','',td);
           a.setAttribute('data-route-id', this._savedRoutes[i].id);
           a.setAttribute('style','cursor:pointer');
           a.innerHTML = '<i class="fa fa-trash-o"></i>';
           L.DomEvent.addListener(a, 'click', L.bind(this._deleteRoute,this));
        }
    },

    signInCallback: function(token, src) {
        if (this._webLoginBlocked()) return;

        var errdiv = L.DomUtil.get("routing-error");
        var http = new XMLHttpRequest();
        http.open('GET', '/ors/login', true);

        if (src == "google") {
           http.setRequestHeader('X-Google-Token', token);
        } else if (src == "apple") {
           http.setRequestHeader('X-Apple-Token', token);
        }

        http.onreadystatechange = L.bind(function() {
            if (http.readyState == 4 && http.status >= 200 && http.status < 300) {
                errdiv.style.visibility = 'hidden';

                this._accessToken = http.responseText;
                try { localStorage.setItem('accessToken', this._accessToken); } catch (error) {}
                this._signInComplete();

            } else if (http.readyState == 4 && http.status >= 400) {
                control.fire('routingerror', {error: {message:'Authentication failed, please sign out and sign back in'}});
            }
        },this);

        http.onerror = L.bind(function(e) {
           control.fire('routingerror', {error: {message:'Authentication failed, please sign out and sign back in'}});
        }, this);

        http.ontimeout = http.onerror;
        http.send();
    },

    _signInComplete: function() {
        L.DomUtil.get('favs-login-container').style.display = 'none';
        L.DomUtil.get('favs-logged-in-container').style.display = 'block';
        this._refreshSavedRouteList();
    },

    signOutCallback: function() {
        L.DomUtil.get('favs-login-container').style.display = 'block';
        L.DomUtil.get('favs-logged-in-container').style.display = 'none';
        this._accessToken = null;
        try { localStorage.removeItem('accessToken'); } catch (error) {}
        this._savedRoutes = [];
        if (this._routeTable) this._displaySavedRouteList();
    },

    _routeAction: function(event) {
        var anchor = event.currentTarget;
        var id = anchor && anchor.getAttribute('data-route-id');
        var row = anchor && anchor.parentNode && anchor.parentNode.parentNode;
        if (!row || row.parentNode !== this._routeTable || id === null) return null;
        var routes = this._savedRoutes || [];
        for (var i = 0; i < routes.length; i++) {
            if (String(routes[i].id) === id) return { route: routes[i], row: row };
        }
        // The list changed while the action was pending.
        this._displaySavedRouteList();
        return null;
    },

    _renameRoute: function(el) {

        var action = this._routeAction(el);
        if (!action) return;
        var route = action.route;
        var tr = action.row;

        while (tr.firstChild) {
           tr.removeChild(tr.firstChild);
        }

        // route name
        var td = L.DomUtil.create('td', 'c1', tr);
        var input = L.DomUtil.create('input','',td);
        input.setAttribute('maxlength','256');
        input.value = route.name;

        // save button
        td = L.DomUtil.create('td', 'c2', tr);
        var a = L.DomUtil.create('a','',td);
        a.setAttribute('style','cursor:pointer');
        a.innerHTML = '<i class="fa fa-check"></i>';
        L.DomEvent.addListener(a, 'click', L.bind(function() {
           var body = { name: input.value };
           this._restCall('PATCH', '/ors/savedroutes?id='+encodeURIComponent(route.id), body, L.bind(this._refreshSavedRouteList,this));
        },this));

        // cancel link
        td = L.DomUtil.create('td', 'c3', tr);
        a = L.DomUtil.create('a','',td);
        a.setAttribute('style','cursor:pointer');
        a.innerHTML = '<i class="fa fa-ban"></i>';
        L.DomEvent.addListener(a, 'click', L.bind(this._refreshSavedRouteList,this));
    },

    _deleteRoute: function(el) {
        var action = this._routeAction(el);
        if (!action) return;
        var route = action.route;
        if (confirm(L.localisation.get('share.deleteConfirm'))) {
           this._restCall('DELETE', '/ors/savedroutes?id='+encodeURIComponent(route.id), null, L.bind(this._refreshSavedRouteList,this));
        }
    },

    _saveRoute: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

        var body = {
           name: control._selectedRoute.resolveName(),
           url: window.location.href,
           geometry: control._selectedRoute.geometry,
           distance: control._selectedRoute.summary.totalDistance
        }

        this._restCall('POST', '/ors/savedroutes', body, L.bind(this._refreshSavedRouteList,this));
    },

    _restCall: function(verb, path, data, cb) {

        var errdiv = L.DomUtil.get("routing-error");
        var http = new XMLHttpRequest();
        var url = path;
        http.open(verb, url, true);

        // set TR token
        var token = this._accessToken;
        http.setRequestHeader('X-Access-Token', token);

        if (data)
           http.setRequestHeader('Content-type', 'application/json');

        http.onreadystatechange = L.bind(function() {
            if (http.readyState == 4 && http.status >= 200 && http.status < 300) {
                errdiv.style.visibility = 'hidden';
                if (cb) cb(http.responseText);
            } else if (http.readyState == 4 && http.status >= 400) {
                control.fire('routingerror', {error: {message:'Authentication failed, please sign out and sign back in'}});
            }
        },this);

        http.onerror = L.bind(function(e) {
            errdiv.innerHTML = e;
            errdiv.style.visibility = 'visible';
        }, this);

        http.ontimeout = http.onerror;
        if (data) {
           http.send(JSON.stringify(data));
        } else {
           http.send();
        }
    },

    _shortenSuccess: function(response) {
            this.linkInput.value = response;
            this.linkInput.style.display = 'block';
            this.linkInput.disabled = false;
            this.linkInput.select();
            this.linkInput.setSelectionRange(0, 99999);
            document.execCommand("copy");
            this.linkInput.disabled = true;
    },

    _shortenUrl: function() {

        if (!this._hasRoute()) {
           alert(L.localisation.get('error.plotRouteFirst'));
           return;
        }

        var routeUrl = window.location.href;
        var requestId = this._shortenRequestId = (this._shortenRequestId || 0) + 1;
        // Cache the URL and its response together, only after a successful request.
        if (this._shortenedUrl && this._shortenedUrl.url === routeUrl) {
           this._shortenSuccess(this._shortenedUrl.response);
           return;
        }

        this.linkInput.value = '';

        var errdiv = L.DomUtil.get("routing-error");
        var http = new XMLHttpRequest();
        var url = '/shorten';
        var params = 'url='+encodeURIComponent(routeUrl);
        http.open('POST', url, true);
        http.timeout = 15000;
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        var finished = false;
        var complete = L.bind(function(success) {
            if (finished) return;
            finished = true;
            if (requestId !== this._shortenRequestId || window.location.href !== routeUrl || !this._hasRoute()) return;
            if (success) {
                errdiv.style.visibility = 'hidden';
                this._shortenedUrl = { url: routeUrl, response: http.responseText };
                this._shortenSuccess(http.responseText);
            } else {
                control.fire('routingerror', {error: {message:'URL shortening failed'}});
            }
        }, this);

        http.onreadystatechange = function() {
            if (http.readyState === 4) complete(http.status === 201);
        };

        http.onerror = function() { complete(false); };
        http.ontimeout = http.onerror;
        http.send(params);
    }
});
